export default defineNuxtRouteMiddleware((to) => {
	const env = useEnv()

	if (env.isProd) {
		if (
			to.path.startsWith('/partners/auroraenergy') ||
			to.path.startsWith('/partners/sonnendrive')
		) {
			return navigateTo('/', { redirectCode: 307 })
		}
	}
})
